import * as Yup from "yup";

export const energyContentSchema = Yup.number()
    .integer("Value cannot contain decimals")
    .min(0, "Cannot be negative")
    .max(99999, "Must be 99999 or less")
    .nullable(true);
